import { RepositoryFactory } from "../repositories/RepositoryFactory";

const tarifRepository = RepositoryFactory.get("tarif");

const tarif = {
  namespaced: false,
  state: {
    error: null,
  },
  mutations: {
    error(state, status) {
      state.error = status;
    },
  },
  actions: {
    getTarife({ commit }, payload) {
      console.log("storettt", payload);
      return tarifRepository
        .getTarifePost(payload)
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {});
    },
    getAnalyse({ commit }) {
      return tarifRepository
        .getAnalyse()
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {});
    },

    getAnalyseShort({ commit }, tarif_id) {
      return tarifRepository
        .getAnalyseShort(tarif_id)
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {});
    },
    getAnalyseTarif({ commit }, tarif_id) {
      return tarifRepository
        .getAnalyseTarif(tarif_id)
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {});
    },
    postTarifStore({ commit }, payload) {
      return tarifRepository
        .postTarifRepo(payload)
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {});
    },
    getTarifStore({ commit }, payload) {
      return tarifRepository
        .getTarifRepo(payload)
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {});
    },

    getAntworten({ commit }, payload) {
      return tarifRepository
        .getAntworten(payload)
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {});
    },
    getHomeVms({ commit }) {
      return tarifRepository
        .getHomeVms()
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {});
    },
  },

  getters: {},
};

export default tarif;
